import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() show: boolean;
  @Input() name: string;
  @Input() paddingTop: string;
  @Input() paddingBottom: string;
  @Input() paddingLeft: string;
  @Input() paddingRight: string;

  constructor( private spinnerService: SpinnerService ) {
    this.show = false;
  }

  ngOnInit() {
    this.spinnerService._register(this);
    if (!this.name) {
      throw new Error('Spinner have to be named');
    }
  }

}
